export default {
  floatingTopMenu: {
    openSettings: 'Settings',
    showAbout: 'Show general information',
    about: 'About ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'Openrouteservice for disasters',
    askOpenrouteservice: 'Ask openrouteservice',
    settingsTooltip: 'Click here if you want to adjust app settings and see other options',
    shadedRoutingLink: 'https://heigit.org/heat-resilient-mobility-in-80-major-german-cities-and-an-invitation-to-shape-its-future/',
    shadedRouting: 'About Shaded Routing'
  }
}
